import { ReactNode } from "react";
import { DCMouseEventHandler } from "@/stores/RootStoreContext";
import { IconButton } from "@/components-v2/Button";
import { TMessage } from "@/i18n/tt";
import { classNames } from "@/utils/classNames";

export type DismissableProps = {
  onDismiss?: DCMouseEventHandler<HTMLButtonElement>;
  tooltip?: string | TMessage;
  show?: "hover" | "always";
  children: ReactNode;
};

export function Dismissable({ onDismiss, tooltip, show = "hover", children }: DismissableProps) {
  if (!onDismiss) {
    return children;
  }
  return (
    <div className={"relative inline-flex group/dismissable"}>
      {children}
      <IconButton
        icon={{ name: "x", size: "sm" }}
        compact
        color={"gray"}
        tooltip={tooltip ?? { key: "delete" }}
        onClick={onDismiss}
        className={classNames(
          "absolute",
          "-top-3",
          "-right-3",
          "p-1",
          "bg-default",
          "border",
          "border-gray",
          show === "hover" && [
            "invisible",
            "transition-[visibility]",
            "delay-300",
            "group-hover/dismissable:visible",
            "group-hover/dismissable:delay-0",
            "group-focus-within/dismissable:visible",
            "group-focus-within/dismissable:delay-0",
          ],
        )}
      />
    </div>
  );
}
